/* mypka-nachkauf-auswahl.js — myPKA, 20.08.2026 (ClickUp 869emgd9n / PR21-5544)
 *
 * Custom Element <mypka-nachkauf> — der Auswahl-Drawer der Nachkauf-PDP.
 *
 * STAND 2 (Erdem, 20.08.2026, nach Sichtung der Aufnahmen):
 *   1. "Genau 10" ist die Regel, keine Option. Die Oberflaeche sagt das vom
 *      ersten Blick an (Buy-Box-Zeile, Drawer-Untertitel, Statuszeile), statt
 *      den Kunden bei 9 Stueck gegen eine Wand laufen zu lassen.
 *   2. Die Auswahl liegt im Drawer mit Suche. Die Seite hat eine normale
 *      Buy-Box; deren Knopf heisst NICHT "In den Warenkorb", sondern
 *      "10 Favoriten waehlen" — er kann bei "genau 10" nichts in den Warenkorb
 *      legen, er oeffnet die Auswahl. Der Kaufen-Knopf sitzt unten im Drawer.
 *
 * Aufgaben:
 *   a) Drawer: oeffnen/schliessen (Aussenklick, ESC, Kreuz), Fokusfalle,
 *      Fokusrueckkehr auf den
 *      TATSAECHLICHEN Ausloeser, Hintergrund nicht scrollbar. Optik und
 *      Bewegung kommen aus den .drawer-Klassen des Themes
 *      (component-cart-drawer.css) — kein zweiter Drawer-Stack. Die Fokusfalle
 *      ist bewusst EIGEN und nicht global.js' trapFocus: das merkt sich erstes
 *      und letztes Element beim Oeffnen, hier aendert die Suche aber laufend,
 *      welche Zeilen im Dokument sichtbar sind. Gemessen: mit der gemerkten
 *      Liste lief der Fokus vom Kaufen-Knopf aus dem Dialog heraus.
 *      DER AUSSENKLICK ist eine pointerdown/pointerup-Paarung auf DEMSELBEN
 *      Ziel, kein `click` — Begruendung an der Stelle. Die getroffene Auswahl
 *      bleibt beim Schliessen stehen; zurueckgesetzt wird sie ausschliesslich
 *      nach einem erfolgreichen Warenkorb-Zulauf (beiWarenkorb).
 *   b) Suche: reiner clientseitiger Filter ueber die Artikeltitel. Sofort beim
 *      Tippen, diakritik- und grossschreibungsunabhaengig, mit sichtbarem
 *      "keine Treffer"-Zustand und Ein-Klick-Leeren. BEREITS GEWAEHLTE ARTIKEL
 *      BLEIBEN GEWAEHLT, auch wenn sie gerade herausgefiltert sind — der
 *      Zaehler wird ueber ALLE Zeilen gerechnet, nie ueber die sichtbaren.
 *   c) Mengenwaehler je Position mit gemeinsamem Gesamtlimit.
 *   d) Auswahl laufend als Line-Item-Properties in versteckte Inputs spiegeln —
 *      nicht erst beim Absenden. product-form.js haengt seinen submit-Listener
 *      im Konstruktor auf, also VOR diesem Script; ein eigener submit-Listener
 *      liefe zu spaet, um das FormData noch zu ergaenzen.
 *   e) Nach erfolgreichem Hinzufuegen: Drawer schliessen, Zaehler auf 0. Das
 *      Limit gilt je Warenkorbposition, nicht je Bestellung.
 *
 * Der Ausloeser sitzt in einer ANDEREN Sektion (main-product). Deshalb ein
 * einziger delegierter Klick-Listener am document statt Bindungen je Knopf —
 * das ueberlebt jedes Re-Rendering im Theme-Editor ohne Doppelbindung.
 *
 * Ohne JavaScript: die Buy-Box zeigt ihren <noscript>-Hinweis und gar keinen
 * Knopf (die Klasse `mypka-nachkauf-bereit` setzt ein Inline-Script im
 * Drawer-Markup). Der Kaufen-Knopf im Drawer traegt serverseitig `disabled`,
 * erst dieses Script nimmt es weg.
 */

(function () {
	'use strict';

	/* --- Diakritik-Faltung -------------------------------------------------
	 * Query und Artikeltitel werden mit DERSELBEN Funktion gefaltet — nur so
	 * kann die Suche nicht asymmetrisch werden. Erst Kleinschreibung, dann
	 * NFD-Zerlegung + Wegwerfen der kombinierenden Zeichen (deckt á à ä â ã å
	 * é è ê ë í ì î ï ñ ó ò ô õ ö ú ù û ü ç …), danach die Zeichen, die sich
	 * nicht zerlegen lassen.
	 */
	function falte(text) {
		return String(text == null ? '' : text)
			.toLowerCase()
			.normalize('NFD')
			.replace(/[\u0300-\u036f]/g, '')
			.replace(/ß/g, 'ss') // ß
			.replace(/æ/g, 'ae') // æ
			.replace(/œ/g, 'oe') // œ
			.replace(/ø/g, 'o') // ø
			.replace(/đ/g, 'd') // đ
			.replace(/ł/g, 'l') // ł
			.replace(/ı/g, 'i') // ı
			.replace(/\s+/g, ' ')
			.trim();
	}

	/* --- Fokusziele -------------------------------------------------------
	 * Bewusst NICHT global.js' trapFocus: das merkt sich erste/letztes Element
	 * beim Oeffnen. Hier aendert die Suche laufend, welche Zeilen ueberhaupt da
	 * sind — eine gemerkte Liste ist damit ab dem ersten Tastendruck falsch.
	 * Deshalb wird die Liste bei JEDEM Tab neu erhoben, und unsichtbare
	 * Elemente (gefilterte Zeilen, verborgener Leeren-Knopf) fallen raus.
	 */
	function fokusziele(container) {
		if (!container) return [];
		var auswahl =
			"a[href], button:not([disabled]), input:not([type=hidden]):not([disabled]), " +
			"select:not([disabled]), textarea:not([disabled]), summary, " +
			"[tabindex]:not([tabindex^='-'])";
		return Array.prototype.filter.call(
			container.querySelectorAll(auswahl),
			function (el) {
				return el.getClientRects().length > 0;
			}
		);
	}

	function fuelleVorlage(vorlage, werte) {
		var text = String(vorlage == null ? '' : vorlage);
		Object.keys(werte).forEach(function (schluessel) {
			text = text.split('{' + schluessel + '}').join(String(werte[schluessel]));
		});
		return text;
	}

	if (!customElements.get('mypka-nachkauf')) {
		customElements.define(
			'mypka-nachkauf',
			class MypkaNachkauf extends HTMLElement {
				connectedCallback() {
					if (this.initialisiert) return;
					this.initialisiert = true;

					/* Der Drawer muss `position: fixed` gegen den Viewport rechnen.
					 * Jede kuenftige `transform`/`filter`-Regel an einem Vorfahren
					 * wuerde daraus einen neuen Containing Block machen. Deshalb wie
					 * ModalDialog im Theme: einmal an <body> haengen. Alte Zwillinge
					 * aus einem Theme-Editor-Re-Render vorher entfernen, sonst gaebe
					 * es doppelte IDs. */
					if (this.parentElement !== document.body) {
						var meineId = this.id;
						Array.prototype.forEach.call(
							document.querySelectorAll('body > mypka-nachkauf'),
							function (alt) {
								if (alt.id === meineId) alt.remove();
							}
						);
						document.body.appendChild(this);
					}

					this.limit = parseInt(this.dataset.limit, 10) || 10;
					this.pflichtVoll = this.dataset.pflichtVoll === 'true';
					this.varianteId = String(this.dataset.varianteId || '');
					this.quelle = this.dataset.quelle || '';
					this.einheit = this.dataset.einheit || 'Stück';

					this.texte = {
						triggerLabel: this.dataset.triggerLabel || '{limit} Favoriten wählen',
						regel: this.dataset.textRegel || 'Noch {rest} von {limit} wählen.',
						offen: this.dataset.textOffen || 'Noch {rest} von {limit} frei.',
						voll: this.dataset.textVoll || '{limit} von {limit} gewählt.',
						ueberlauf: this.dataset.textUeberlauf || 'Mehr als {limit} geht nicht.',
						hinzugefuegt: this.dataset.textHinzugefuegt || 'Im Warenkorb.',
						stand: this.dataset.textStand || 'Genau {limit} Artikel.',
						treffer: this.dataset.textTreffer || '{treffer} von {gesamt} Artikeln passen.',
						keinTreffer: this.dataset.textKeinTreffer || 'Kein Artikel passt zu „{suche}“.',
						ausgeblendet:
							this.dataset.textAusgeblendet ||
							'{versteckt} gewählte Artikel sind durch die Suche gerade ausgeblendet.'
					};

					this.dialog = this.querySelector('[data-mypka-dialog]');
					this.overlay = this.querySelector('[data-mypka-overlay]');
					this.schliessKnopf = this.querySelector('[data-mypka-schliessen]');
					this.suchfeld = this.querySelector('[data-mypka-suchfeld]');
					this.sucheReset = this.querySelector('[data-mypka-suche-reset]');
					this.trefferEl = this.querySelector('[data-mypka-treffer]');
					this.leertrefferEl = this.querySelector('[data-mypka-leertreffer]');
					this.scrollEl = this.querySelector('[data-mypka-scroll]');
					this.propsHost = this.querySelector('[data-mypka-props]');
					this.panel = this.querySelector('[data-mypka-panel]');
					this.statusEl = this.querySelector('[data-mypka-status]');
					this.zahlEl = this.querySelector('[data-mypka-gewaehlt]');
					this.balken = this.querySelector('[data-mypka-balken]');
					this.ausgeblendetEl = this.querySelector('[data-mypka-ausgeblendet]');
					this.submit = this.querySelector('[data-mypka-submit]');
					this.zeilen = Array.prototype.slice.call(
						this.querySelectorAll('[data-mypka-zeile]')
					);

					if (!this.propsHost || !this.zeilen.length) return;

					/* icon-search.liquid liefert sein <svg> mit tabindex="0" aus. Im
					 * Drawer waere das ein fokussierbares Dekoelement — und es zaehlt in
					 * getFocusableElements() mit, koennte also das erste Element der
					 * Fokusfalle werden. Hier lokal entschaerfen statt den geteilten
					 * Icon-Snippet des Themes anzufassen. */
					Array.prototype.forEach.call(
						this.querySelectorAll('svg[tabindex]'),
						function (svg) {
							svg.removeAttribute('tabindex');
							svg.setAttribute('aria-hidden', 'true');
							svg.setAttribute('focusable', 'false');
						}
					);

					// Suchschluessel einmal vorberechnen — nicht bei jedem Tastendruck.
					var self = this;
					this.zeilen.forEach(function (zeile) {
						zeile.mypkaSuchtext = falte(zeile.dataset.mypkaTitel || '');
						zeile.mypkaEingabe = zeile.querySelector('[data-mypka-input]');
					});

					// Ab hier steuert JS den Knopf; ohne JS bleibt er hart deaktiviert.
					if (this.submit) this.submit.removeAttribute('disabled');

					this.addEventListener('click', this.beiKlick.bind(this));
					this.addEventListener('change', this.beiEingabe.bind(this));
					this.addEventListener('keyup', function (ereignis) {
						if (String(ereignis.code || '').toUpperCase() === 'ESCAPE') {
							self.schliesse();
						}
					});

					// Fokusfalle: Tab am letzten sichtbaren Element geht auf das erste
					// zurueck und umgekehrt.
					this.addEventListener('keydown', function (ereignis) {
						if (String(ereignis.code || '').toUpperCase() !== 'TAB') return;
						var ziele = fokusziele(self.dialog);
						if (!ziele.length) return;
						var erstes = ziele[0];
						var letztes = ziele[ziele.length - 1];
						if (ereignis.shiftKey && document.activeElement === erstes) {
							ereignis.preventDefault();
							letztes.focus();
						} else if (!ereignis.shiftKey && document.activeElement === letztes) {
							ereignis.preventDefault();
							erstes.focus();
						}
					});

					/* Zweite Schicht: alles, was den Fokus trotzdem nach draussen zieht
					 * (Cookie-Banner, App-Einbettung, Adressleiste), wird zurueckgeholt.
					 * Ein Modal, aus dem der Fokus wegrutschen kann, ist keins. */
					document.addEventListener('focusin', function (ereignis) {
						if (!self.offen || !self.dialog) return;
						if (self.dialog.contains(ereignis.target)) return;
						var ziele = fokusziele(self.dialog);
						(ziele[0] || self.dialog).focus();
					});

					/* --- Aussenklick ------------------------------------------------
					 * BEWUSST pointerdown/pointerup-PAARUNG statt `click`.
					 *
					 * Ein `click` entsteht auch dann, wenn Druecken und Loslassen auf
					 * VERSCHIEDENEN Elementen passieren — der Browser waehlt dann den
					 * gemeinsamen Vorfahren als Ziel. Wer am Mengenwaehler zieht und
					 * neben dem Drawer loslaesst, erzeugt so einen Klick, dessen Ziel
					 * je nach Engine auch das Overlay sein kann. Deshalb schliesst hier
					 * nur, was drei Bedingungen erfuellt:
					 *   1. Druecken UND Loslassen auf demselben Element,
					 *   2. dieses Element ist die abgedunkelte Flaeche,
					 *   3. der Zeiger hat sich dabei kaum bewegt (kein Zug, kein Wisch).
					 * `pointercancel` raeumt den gemerkten Start weg, sobald der Browser
					 * die Geste selbst uebernimmt (Scrollen/Wischen am Touchgeraet) —
					 * sonst wuerde ein Wisch auf dem Streifen als Aussenklick zaehlen.
					 */
					var zeigerStart = null;
					var zeigerX = 0;
					var zeigerY = 0;
					var ZUG_TOLERANZ = 10; // px zwischen Druecken und Loslassen

					function istPrimaer(ereignis) {
						if (ereignis.isPrimary === false) return false;
						return ereignis.button === undefined || ereignis.button === 0;
					}

					this.addEventListener(
						'pointerdown',
						function (ereignis) {
							if (!istPrimaer(ereignis)) {
								zeigerStart = null;
								return;
							}
							zeigerStart = ereignis.target;
							zeigerX = ereignis.clientX;
							zeigerY = ereignis.clientY;
						},
						true
					);

					this.addEventListener(
						'pointercancel',
						function () {
							zeigerStart = null;
						},
						true
					);

					this.addEventListener(
						'pointerup',
						function (ereignis) {
							var start = zeigerStart;
							zeigerStart = null;
							if (!self.offen || !self.overlay) return;
							if (!istPrimaer(ereignis)) return;
							if (!start || start !== ereignis.target) return;
							if (ereignis.target !== self.overlay) return;
							var dx = ereignis.clientX - zeigerX;
							var dy = ereignis.clientY - zeigerY;
							if (dx * dx + dy * dy > ZUG_TOLERANZ * ZUG_TOLERANZ) return;
							self.schliesse();
						},
						true
					);

					/* Ruecklage fuer Engines ohne Pointer Events. Dort gibt es die
					 * Paarung nicht — wenigstens die Zielpruefung. */
					if (!('PointerEvent' in window) && this.overlay) {
						this.overlay.addEventListener('click', function (ereignis) {
							if (ereignis.target === self.overlay) self.schliesse();
						});
					}

					if (this.suchfeld) {
						this.suchfeld.addEventListener('input', function () {
							self.filtere();
						});
						// Enter darf nichts ausloesen. Das Suchfeld liegt zwar ausserhalb
						// des <form>, aber ein kuenftiger Umbau soll hier nicht stolpern.
						this.suchfeld.addEventListener('keydown', function (ereignis) {
							if (String(ereignis.code || '').toUpperCase() === 'ENTER') {
								ereignis.preventDefault();
							}
						});
					}

					if (this.sucheReset) {
						this.sucheReset.addEventListener('click', function () {
							self.leereSuche(true);
						});
					}

					/* product-form.js nimmt in seinem finally() das aria-disabled vom
					 * Submit-Knopf — auch dann, wenn unsere Auswahl danach wieder auf 0
					 * steht. Das Ergebnis waere ein freigegebener Kaufen-Knopf ohne
					 * Auswahl. Der Beobachter setzt den Zustand deshalb zurueck, sobald
					 * er von aussen aufgeweicht wird. Er greift nur in eine Richtung
					 * (ungueltig -> wieder sperren) und kann daher keinen Ladezustand
					 * ueberschreiben. */
					if (this.submit && typeof MutationObserver === 'function') {
						this.wache = new MutationObserver(function () {
							if (
								self.gueltig === false &&
								self.submit.getAttribute('aria-disabled') !== 'true'
							) {
								self.submit.setAttribute('aria-disabled', 'true');
							}
						});
						this.wache.observe(this.submit, {
							attributes: true,
							attributeFilter: ['aria-disabled']
						});
					}

					if (
						typeof subscribe === 'function' &&
						typeof PUB_SUB_EVENTS !== 'undefined'
					) {
						subscribe(PUB_SUB_EVENTS.cartUpdate, this.beiWarenkorb.bind(this));
					}

					this.filtere();
					this.synchronisiere();
				}

				/* --- Ausloeser (liegen in main-product, nicht hier) -------------- */

				ausloeser() {
					if (!this.id) return [];
					return Array.prototype.slice.call(
						document.querySelectorAll(
							'[data-mypka-oeffnen][aria-controls="' + this.id + '"]'
						)
					);
				}

				/* --- Drawer ------------------------------------------------------ */

				oeffne(ausloeser) {
					if (this.offen) return;
					this.offen = true;

					/* Fokusrueckkehr: den TATSAECHLICHEN Ausloeser beim Klick festhalten.
					 * Niemals aus einem Zustand ableiten, den das Schliessen selbst
					 * veraendert — genau daran ist mir das schon einmal gerissen
					 * (Journal 2026-06-19, shared Dialog mit zwei Triggern). */
					this.oeffner = ausloeser || this.oeffner || null;

					this.ausloeser().forEach(function (knopf) {
						knopf.setAttribute('aria-expanded', 'true');
					});

					this.classList.add('animate', 'active');
					document.body.classList.add('overflow-hidden-drawer');

					var self = this;
					var breit =
						window.matchMedia && window.matchMedia('(min-width: 750px)').matches;
					// Am Desktop ist die Suche der Einstieg; mobil waere ein Autofokus
					// auf das Textfeld die sofort aufpoppende Tastatur, die genau die
					// Liste verdeckt, die man sehen will. Dort bekommt der Dialog selbst
					// den Fokus (tabindex=-1): Screenreader lesen Rolle und Titel, der
					// erste Tab landet auf dem Schliessen-Knopf.
					var ziel = breit && this.suchfeld ? this.suchfeld : this.dialog;

					window.clearTimeout(this.fokusTimer);
					this.fokusTimer = window.setTimeout(function () {
						(ziel || self.dialog).focus();
					}, 50);
				}

				schliesse() {
					if (!this.offen) return;
					this.offen = false;

					window.clearTimeout(this.fokusTimer);
					this.classList.remove('active');
					document.body.classList.remove('overflow-hidden-drawer');

					this.ausloeser().forEach(function (knopf) {
						knopf.setAttribute('aria-expanded', 'false');
					});

					/* Der Warenkorb-Drawer hat sich beim Absenden unseren Submit-Knopf
					 * als Rueckkehrziel gemerkt — der ist gleich unsichtbar. Auf den
					 * Ausloeser umbiegen, sonst landet der Fokus beim Schliessen des
					 * Warenkorbs im Nichts. */
					var warenkorb = document.querySelector('cart-drawer');
					if (warenkorb && this.oeffner && typeof warenkorb.setActiveElement === 'function') {
						warenkorb.setActiveElement(this.oeffner);
					}

					if (this.oeffner) this.oeffner.focus();
				}

				/* --- Suche ------------------------------------------------------- */

				leereSuche(fokussieren) {
					if (!this.suchfeld) return;
					this.suchfeld.value = '';
					this.filtere();
					if (fokussieren) this.suchfeld.focus();
				}

				filtere() {
					var query = falte(this.suchfeld ? this.suchfeld.value : '');
					var aktiv = query.length > 0;
					var treffer = 0;
					var fokusVerloren = false;
					var aktivesElement = document.activeElement;

					this.zeilen.forEach(function (zeile) {
						var passt = !aktiv || zeile.mypkaSuchtext.indexOf(query) !== -1;
						if (passt) {
							treffer += 1;
							zeile.removeAttribute('hidden');
						} else {
							if (aktivesElement && zeile.contains(aktivesElement)) {
								fokusVerloren = true;
							}
							zeile.setAttribute('hidden', '');
						}
					});

					if (this.sucheReset) this.sucheReset.hidden = !aktiv;

					if (this.leertrefferEl) {
						if (treffer === 0) {
							this.leertrefferEl.textContent = fuelleVorlage(
								this.texte.keinTreffer,
								{ suche: this.suchfeld ? this.suchfeld.value.trim() : '' }
							);
							this.leertrefferEl.hidden = false;
						} else {
							this.leertrefferEl.hidden = true;
						}
					}

					// Live-Region entprellt: sonst spricht der Screenreader jeden
					// einzelnen Tastendruck mit.
					var self = this;
					window.clearTimeout(this.trefferTimer);
					this.trefferTimer = window.setTimeout(function () {
						if (!self.trefferEl) return;
						self.trefferEl.textContent = aktiv
							? fuelleVorlage(self.texte.treffer, {
									treffer: treffer,
									gesamt: self.zeilen.length
								})
							: '';
					}, 400);

					// Eine Zeile, in der gerade der Fokus stand, darf nicht einfach
					// unsichtbar werden — sonst faellt der Fokus auf <body> und die
					// Fokusfalle ist gerissen.
					if (fokusVerloren && this.suchfeld) this.suchfeld.focus();

					this.zeigeAusgeblendete(aktiv);
					if (this.scrollEl && aktiv) this.scrollEl.scrollTop = 0;
				}

				zeigeAusgeblendete(sucheAktiv) {
					if (!this.ausgeblendetEl) return;
					var versteckt = 0;
					var self = this;
					this.zeilen.forEach(function (zeile) {
						if (zeile.hasAttribute('hidden') && self.wert(zeile.mypkaEingabe) > 0) {
							versteckt += 1;
						}
					});

					if (!sucheAktiv || versteckt === 0) {
						this.ausgeblendetEl.hidden = true;
						this.ausgeblendetEl.textContent = '';
						return;
					}

					this.ausgeblendetEl.textContent = fuelleVorlage(this.texte.ausgeblendet, {
						versteckt: versteckt
					});
					this.ausgeblendetEl.hidden = false;
				}

				/* --- Zustand ----------------------------------------------------- */

				wert(input) {
					if (!input) return 0;
					var n = parseInt(input.value, 10);
					return isNaN(n) || n < 0 ? 0 : n;
				}

				gesamt() {
					var self = this;
					return this.zeilen.reduce(function (summe, zeile) {
						return summe + self.wert(zeile.mypkaEingabe);
					}, 0);
				}

				/* --- Interaktion -------------------------------------------------- */

				beiKlick(ereignis) {
					var knopf = ereignis.target.closest(
						'[data-mypka-plus], [data-mypka-minus], [data-mypka-submit], [data-mypka-schliessen]'
					);
					if (!knopf) return;

					if (knopf.hasAttribute('data-mypka-schliessen')) {
						ereignis.preventDefault();
						this.schliesse();
						return;
					}

					if (knopf.hasAttribute('data-mypka-submit')) {
						// product-form.js bricht bei aria-disabled="true" selbst ab —
						// hier wird nur der Grund sichtbar gemacht.
						if (knopf.getAttribute('aria-disabled') === 'true') {
							ereignis.preventDefault();
							this.melde(false);
						}
						return;
					}

					ereignis.preventDefault();

					if (knopf.getAttribute('aria-disabled') === 'true') {
						this.melde(knopf.hasAttribute('data-mypka-plus'));
						return;
					}

					var zeile = knopf.closest('[data-mypka-zeile]');
					var input = zeile.mypkaEingabe;
					var richtung = knopf.hasAttribute('data-mypka-plus') ? 1 : -1;

					this.setze(input, this.wert(input) + richtung);
					this.synchronisiere();
				}

				beiEingabe(ereignis) {
					var input = ereignis.target.closest('[data-mypka-input]');
					if (!input) return;
					var gewuenscht = this.wert(input);
					this.setze(input, gewuenscht);
					if (this.wert(input) < gewuenscht) this.melde(true);
					this.synchronisiere();
				}

				setze(input, wunsch) {
					var rest = this.limit - (this.gesamt() - this.wert(input));
					var neu = Math.max(0, Math.min(wunsch, rest));
					input.value = String(neu);
				}

				/* Anschlag erklaeren statt nur blockieren. `ueberlauf` = jemand wollte
				 * eine 11. Position; sonst pulst nur das Panel und die ohnehin
				 * sichtbare Regel bleibt stehen. Kein alert(), kein confirm(). */
				melde(ueberlauf) {
					if (!this.panel) return;
					this.panel.classList.remove('is-hinweis');
					void this.panel.offsetWidth; // Reflow, damit die Animation neu laeuft
					this.panel.classList.add('is-hinweis');

					var self = this;
					window.clearTimeout(this.hinweisTimer);

					if (ueberlauf && this.statusEl) {
						this.statusEl.textContent = fuelleVorlage(this.texte.ueberlauf, {
							limit: this.limit,
							gewaehlt: this.gesamt(),
							rest: 0
						});
						this.ueberlaufAktiv = true;
					}

					this.hinweisTimer = window.setTimeout(function () {
						self.panel.classList.remove('is-hinweis');
						if (self.ueberlaufAktiv) {
							self.ueberlaufAktiv = false;
							self.schreibeStatus();
						}
					}, 4000);
				}

				/* --- Rendering ---------------------------------------------------- */

				synchronisiere() {
					var gesamt = this.gesamt();
					var rest = this.limit - gesamt;
					var voll = rest <= 0;
					var self = this;

					this.gueltig = this.pflichtVoll ? gesamt === this.limit : gesamt > 0;

					this.zeilen.forEach(function (zeile) {
						var n = self.wert(zeile.mypkaEingabe);
						var plus = zeile.querySelector('[data-mypka-plus]');
						var minus = zeile.querySelector('[data-mypka-minus]');
						zeile.classList.toggle('is-gewaehlt', n > 0);
						if (plus) plus.setAttribute('aria-disabled', voll ? 'true' : 'false');
						if (minus) minus.setAttribute('aria-disabled', n <= 0 ? 'true' : 'false');
					});

					if (this.zahlEl) this.zahlEl.textContent = String(gesamt);
					if (this.balken) {
						this.balken.style.width =
							Math.min(100, Math.round((gesamt / this.limit) * 100)) + '%';
					}
					if (this.panel) {
						this.panel.classList.toggle('is-voll', voll);
						this.panel.classList.toggle('is-bereit', this.gueltig);
					}
					if (this.submit) {
						this.submit.setAttribute('aria-disabled', this.gueltig ? 'false' : 'true');
					}

					this.schreibeStatus();
					this.zeigeAusgeblendete(
						!!(this.suchfeld && this.suchfeld.value.trim().length)
					);
					this.schreibeAusloeser(gesamt);
					this.schreibeProperties();
				}

				schreibeStatus() {
					if (!this.statusEl || this.ueberlaufAktiv) return;
					var gesamt = this.gesamt();
					var rest = Math.max(0, this.limit - gesamt);
					var werte = { limit: this.limit, gewaehlt: gesamt, rest: rest };
					var vorlage;

					if (rest <= 0) {
						vorlage = this.texte.voll;
					} else if (this.pflichtVoll) {
						vorlage = this.texte.regel;
					} else {
						vorlage = this.texte.offen;
					}

					this.statusEl.textContent = fuelleVorlage(vorlage, werte);
				}

				schreibeAusloeser(gesamt) {
					var self = this;
					var label = fuelleVorlage(this.texte.triggerLabel, { limit: this.limit });
					var werte = {
						limit: this.limit,
						gewaehlt: gesamt,
						rest: Math.max(0, this.limit - gesamt)
					};
					var vorlage;
					if (this.zuletztHinzugefuegt) {
						vorlage = this.texte.hinzugefuegt;
					} else if (gesamt === 0) {
						// Die Regel steht vom ersten Blick an da, nicht erst am Anschlag.
						vorlage = this.texte.stand;
					} else if (gesamt >= this.limit) {
						vorlage = this.texte.voll;
					} else {
						vorlage = this.pflichtVoll ? this.texte.regel : this.texte.offen;
					}
					var stand = fuelleVorlage(vorlage, werte);

					this.ausloeser().forEach(function (knopf) {
						var beschriftung = knopf.querySelector('[data-mypka-trigger-label]');
						if (beschriftung && beschriftung.textContent !== label) {
							beschriftung.textContent = label;
							beschriftung.setAttribute('data-label', label);
						}
						knopf.setAttribute('data-button-text', label);

						var kasten = knopf.closest('.mypka-nachkauf-kaufbox');
						var standEl = kasten && kasten.querySelector('[data-mypka-stand]');
						if (standEl && standEl.textContent !== stand) {
							standEl.textContent = stand;
						}
						if (gesamt > 0 && !self.zuletztHinzugefuegt) {
							knopf.setAttribute('data-mypka-teilauswahl', String(gesamt));
						} else {
							knopf.removeAttribute('data-mypka-teilauswahl');
						}
					});
				}

				/* --- Line-Item-Properties ------------------------------------------
				 * Sichtbar je gewaehlter Position:
				 *   properties[<Artikeltitel>] = "<Menge> Stück"
				 * Technisch (Unterstrich = vor dem Kunden verborgen):
				 *   _nachkauf_gesamt, _nachkauf_limit, _nachkauf_quelle
				 * Hier wird ueber ALLE Zeilen iteriert, nicht ueber die sichtbaren —
				 * eine aktive Suche darf die Bestellung nicht beschneiden.
				 *
				 * `_nachkauf_auswahl` ENTFERNT am 31.08.2026 (Erdem).
				 * Es trug dieselbe Auswahl noch einmal als JSON. Der Unterstrich
				 * versteckt eine Property im SHOP, nicht im Adminbereich — dort zeigt
				 * Shopify alle. In der Bestellung stand die Liste deshalb zweimal:
				 * einmal lesbar, einmal als JSON-Block quer ueber die Position.
				 * Verloren geht nichts: Titel und Menge stehen in den sichtbaren
				 * Zeilen, maschinell genauso auswertbar (`<Titel>: <n> Stück`).
				 * Es stammte aus dem Vertrag mit Mohsan (Ticket 869ejkn9p); der ist
				 * nicht mehr im Projekt, das Feld hatte keinen Abnehmer mehr.
				 */

				verstecktes(name, wert) {
					var input = document.createElement('input');
					input.type = 'hidden';
					input.name = name;
					input.value = wert;
					return input;
				}

				schreibeProperties() {
					var self = this;
					var gesamt = 0;

					while (this.propsHost.firstChild) {
						this.propsHost.removeChild(this.propsHost.firstChild);
					}

					this.zeilen.forEach(function (zeile) {
						var n = self.wert(zeile.mypkaEingabe);
						if (n <= 0) return;
						var titel = zeile.dataset.mypkaTitel || '';
						var schluessel = zeile.dataset.mypkaProp || titel;
						self.propsHost.appendChild(
							self.verstecktes('properties[' + schluessel + ']', n + ' ' + self.einheit)
						);
						gesamt += n;
					});

					if (gesamt === 0) return;

					this.propsHost.appendChild(
						this.verstecktes('properties[_nachkauf_gesamt]', String(gesamt))
					);
					this.propsHost.appendChild(
						this.verstecktes('properties[_nachkauf_limit]', String(this.limit))
					);
					if (this.quelle) {
						this.propsHost.appendChild(
							this.verstecktes('properties[_nachkauf_quelle]', this.quelle)
						);
					}
				}

				/* --- Nach dem Hinzufuegen ------------------------------------------ */

				beiWarenkorb(nachricht) {
					if (!nachricht || nachricht.source !== 'product-form') return;
					if (String(nachricht.productVariantId || '') !== this.varianteId) return;

					this.zeilen.forEach(function (zeile) {
						if (zeile.mypkaEingabe) zeile.mypkaEingabe.value = '0';
					});

					this.zuletztHinzugefuegt = true;
					this.ueberlaufAktiv = false;
					this.leereSuche(false);
					this.synchronisiere();
					this.schliesse();

					// Der naechste Handgriff des Kunden setzt die Quittung zurueck.
					var self = this;
					window.clearTimeout(this.quittungTimer);
					this.quittungTimer = window.setTimeout(function () {
						self.zuletztHinzugefuegt = false;
						self.schreibeAusloeser(self.gesamt());
					}, 12000);
				}
			}
		);
	}

	/* Ein einziger delegierter Listener fuer alle Ausloeser — sie liegen in
	 * einer anderen Sektion (main-product) und werden im Theme-Editor
	 * unabhaengig neu gerendert. Bindungen je Knopf wuerden sich dort
	 * verdoppeln oder ins Leere zeigen. */
	if (!window.mypkaNachkaufAusloeserGebunden) {
		window.mypkaNachkaufAusloeserGebunden = true;
		document.addEventListener('click', function (ereignis) {
			var knopf =
				ereignis.target.closest && ereignis.target.closest('[data-mypka-oeffnen]');
			if (!knopf) return;
			var id = knopf.getAttribute('aria-controls');
			var drawer = id ? document.getElementById(id) : null;
			if (!drawer || typeof drawer.oeffne !== 'function') return;
			ereignis.preventDefault();
			drawer.oeffne(knopf);
		});
	}
})();
